// import * as React from 'react';
// import Box from '@mui/material/Box';
import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Tabp from '../../ui/tabpanel'
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Link
} from "react-router-dom";
// import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';
// import Toddle from '../pages/modal';
import { getsitedata, logout } from "./../action/user";
import { confirm } from "react-confirm-box";
import swal from "sweetalert";
import Navbar from "../Navbar/Navbar";
import { getcaste, getregister } from "./../action/user";
import { useLocation } from 'react-router-dom';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  height: 'auto',
  bgcolor: 'background.paper',
  // border: '2px solid #ff6ed',
  boxShadow: 24,
  p: 4,
  borderRadius: '25px'


};



function Header() {


  // const castes = await test.userValue.map(d => ({
  //   "title": d.castename,
  //   "value": d.castename
  // }));
  // console.log("fdssfdsfdsf", castes);
  // setcaste(castes);



  const [sites, setSites] = useState([])
  const [totalcount, settotalcount] = useState(0)
  const getPieData = async () => {
    var test = await getsitedata();
    setSites(test.userValue[0]);
    settotalcount(test.totalCount)
  }
  const onlogout = async () => {
    const log = await swal("Are you sure do you want to logout?");
    if (log) {
      var test = await logout();
      window.location = "/";
    }
  }



  useEffect(() => {
    //logout(history)
    getPieData();
  }, []);






  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  // navbar
  const [openspinner, setOpenspinner] = useState(true);
  const [registers, setRegisters] = useState([])
  const getUserData = async () => {
    var test = await getregister();
    setRegisters(test.userValue);
    // console.log(test, "twinkle");
  }


  useEffect(() => {
    //logout(history)
    getUserData();
  }, []);


  const [castes, setCastes] = useState([])
  const getPacksData = async () => {
    var test = await getcaste();
    setCastes(test.userValue);
    // console.log(test, "twinkle");
    // alert(openspinner);
    setInterval(setOpenspinner(!openspinner), 200);


  }


  useEffect(() => {
    //logout(history)
    // setOpenspinner(!openspinner);
    getPacksData();
  }, []);


  const [click, setClick] = useState(false);
  // const [open, setOpen] = React.useState(false);
  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);


  // Check if we are on homepage
  const location = useLocation();
  const isHome = location.pathname === '/';


  // let isMyprofile = false;
  const currentPath = window.location.pathname;
  const myprofileArr = ['/myprofile', '/showCard', '/anotherviewed', '/saved', '/membership'];
  const isMyprofile = myprofileArr.includes(currentPath);


  const routeArr = ['/', '/about', '/contact', '/payment',];
  const headerVisible = routeArr.includes(currentPath);
  const headerStyle = {
    color: "rgb(73 67 67)",
    fontWeight: "bold",
  }

  return (

    <header
    //  style={{
    //   position: 'fixed',
    //   top: '0',
    //   left: '0',
    //   right: '0',
    //   width: '100%',
    //   zIndex: '1000',
    //   backgroundColor: 'white',
    // }}
    >
      {/* transparent only on homepage */}
      <div
        className="borderzz"
        style={{
          backgroundColor: 'transparent',
          position: (isMyprofile || !headerVisible) ? '' : 'absolute',
          top: 'auto',
          width: '100%',
          zIndex: 50,
          height: '103px',
          boxShadow: (isMyprofile || !headerVisible) ? '0 0px 10px rgba(0, 0, 0, 0.2)' : '',
        }}
      >
        <div className="modal fade" id="myModal" role="dialog">cd websit
          <div className="modal-dialog">
            {/* Modal content*/}
            <div className="modal-content" style={{ "border-radius": "20px" }}>
              <button type="button" className="close" data-dismiss="modal">×</button>
              <div className="modal-body member-login-popup">
                <ul className="nav nav-pills">
                  <li><i className="fa fa-heart-o" aria-hidden="true" /><a data-toggle="pill" href="#find" id="mysoul">FIND MY SOULMATE</a></li>
                  <li className="active"><i className="fa fa-user-circle-o" aria-hidden="true" /><a data-toggle="pill" href="#mlogin" id="mylogin">MEMBER LOGIN</a></li>
                </ul>
                <div className="tab-content">
                  <div id="find" className="tab-pane fade">
                    <form method="get" action="searchresult">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-6">
                            <label>mano </label>
                            <input type="text" placeholder="Search by ID (Ex : TMM-200)" autoComplete="off" defaultValue className="form-control validate[required]" name="n" />
                            {/*<input type="text" class="form-control" name="id" onkeypress="javascript:convertThis(event);">*/}
                          </div>
                          <div className="col-md-6">
                            <label>Search </label>


                            <select className="form-control validate[required]" name="marital">
                              <option value>---Select---</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Religion</label>
                            <select className="form-control validate[required]" name="religion">
                              <option value>---Select---</option>
                              <option value="Hindu">Hindu</option>
                              <option value="Muslim">Muslim</option>
                              <option value="Christian">Christian</option>
                              <option value="Jain">Jain </option>
                              <option value="Jewish">Jewish</option>
                              <option value="Parsi">Parsi</option>
                              <option value="Sikh">Sikh</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label>Caste</label>
                            <select className="form-control validate[required]" name="caste">
                              <option value>---Select---</option>
                              <option value={2}>Nadar</option>
                              <option value={39}>Kuravar</option>
                              <option value={53}>Iyengar</option>
                              <option value={5}>Yadavar</option>
                              <option value={38}>Agamudaiyar</option>
                              <option value={8}>Kallar</option>
                              <option value={9}>Maravar</option>
                              <option value={10}>Chettiar</option>
                              <option value={11}>Christian</option>
                              <option value={12}>Mudaliyar</option>
                              <option value={36}>Naidu</option>
                              <option value={35}>Pillaimar </option>
                              <option value={15}>PR</option>
                              <option value={16}>PL</option>
                              <option value={17}>Rediyar</option>
                              <option value={18}>Counter</option>
                              <option value={19}>Muslim</option>
                              <option value={37}>Vishvakarma</option>
                              <option value={22}>Arundhathiyar</option>
                              <option value={23}>Nair</option>
                              <option value={24}>Moopanar</option>
                              <option value={25}>Dharuthuvar</option>
                              <option value={26}>Veerashaivam</option>
                              <option value={27}>Vannar</option>
                              <option value={28}>Vanniyar</option>
                              <option value={29}>Saurashtra</option>
                              <option value={30}>Nayakar</option>
                              <option value={31}>Vellalar</option>
                              <option value={32}>Udaiar</option>
                              <option value={33}>Muthuraja</option>
                              <option value={34}>Muttaraiyar</option>
                              <option value={40}>Phramin</option>
                              <option value={41}>Vellalar</option>
                              <option value={42}>Thevar Maravar</option>
                              <option value={43}>Valluvar</option>
                              <option value={44}>Karunikar</option>
                              <option value={45}>Meenavar</option>
                              <option value={46}>Iyar</option>
                              <option value={47}>Boyar</option>
                              <option value={48}>Thevar</option>
                              <option value={49}>Valluvan</option>
                              <option value={52}>Kulalar</option>
                              <option value={54}>Iyengar</option>
                              <option value={55}>Pathar</option>
                              <option value={56}>Valayar</option>
                              <option value={58}>Marathi</option>
                              <option value={59}>Yogishwarar</option>
                              <option value={61}>Kathriya Raju</option>
                              <option value={64}>Saathada Srivaishnava</option>
                              <option value={65}>S.T.</option>
                              <option value={66}>Eeluvar</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form_group">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Subdivision</label>
                            <input type="text" className="form-control" name="subcaste" onkeypress="javascript:convertThis(event);" />
                          </div>
                          <div className="col-md-6">
                            <label>Marital status</label>
                            <select className="form-control validate[required]" name="marriage_condition">
                              <option value>---Select---</option>
                              <option value="unmarried"> unmarried</option>
                              <option value="married"> married</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="age-top">Age </label>
                        <div className="row">
                          <div className="col-md-6">
                            <select className="form-control validate[required]" name="from">
                              <option value>---From---</option>
                              <option value={18}>18</option>
                              <option value={19}>19</option>
                              <option value={20}>20</option>
                              <option value={21}>21</option>
                              <option value={22}>22</option>
                              <option value={23}>23</option>
                              <option value={24}>24</option>
                              <option value={25}>25</option>
                              <option value={26}>26</option>
                              <option value={27}>27</option>
                              <option value={28}>28</option>
                              <option value={29}>29</option>
                              <option value={30}>30</option>
                              <option value={31}>31</option>
                              <option value={32}>32</option>
                              <option value={33}>33</option>
                              <option value={34}>34</option>
                              <option value={35}>35</option>
                              <option value={36}>36</option>
                              <option value={37}>37</option>
                              <option value={38}>38</option>
                              <option value={39}>39</option>
                              <option value={40}>40</option>
                              <option value={41}>41</option>
                              <option value={42}>42</option>
                              <option value={43}>43</option>
                              <option value={44}>44</option>
                              <option value={45}>45</option>
                              <option value={46}>46</option>
                              <option value={47}>47</option>
                              <option value={48}>48</option>
                              <option value={49}>49</option>
                              <option value={50}>50</option>
                            </select>
                          </div>
                          <div className="col-md-6">
                            <select className="form-control validate[required]" name="to">
                              <option value>---To---</option>
                              <option value={19}>19</option>
                              <option value={20}>20</option>
                              <option value={21}>21</option>
                              <option value={22}>22</option>
                              <option value={23}>23</option>
                              <option value={24}>24</option>
                              <option value={25}>25</option>
                              <option value={26}>26</option>
                              <option value={27}>27</option>
                              <option value={28}>28</option>
                              <option value={29}>29</option>
                              <option value={30}>30</option>
                              <option value={31}>31</option>
                              <option value={32}>32</option>
                              <option value={33}>33</option>
                              <option value={34}>34</option>
                              <option value={35}>35</option>
                              <option value={36}>36</option>
                              <option value={37}>37</option>
                              <option value={38}>38</option>
                              <option value={39}>39</option>
                              <option value={40}>40</option>
                              <option value={41}>41</option>
                              <option value={42}>42</option>
                              <option value={43}>43</option>
                              <option value={44}>44</option>
                              <option value={45}>45</option>
                              <option value={46}>46</option>
                              <option value={47}>47</option>
                              <option value={48}>48</option>
                              <option value={49}>49</option>
                              <option value={50}>50</option>
                              <option value={51}>51</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div>
                        <input type="submit" name="search" className="button small btn btn-primary" defaultValue="Search" />
                      </div>
                    </form>
                    <div className="advanced-searc-lnk">
                      <a href="/register">New? Register here!</a>
                    </div>
                  </div>
                  <div id="mlogin" className="tab-pane fade in active">
                    <form method="post" action="/login" className="validation_form geting-otp">
                      <div className="form-group">
                        <div className="form-group">
                          <label>Date of birth</label>
                          <input type="text" autoComplete="off" id="dobdatepicker" className="form-control" name="data[Register][date_of_birth]" />
                        </div>
                        {/*<label>பிறந்த தேதி<span class="reguired">*</span></label>                 */}
                        {/*<div class="row">*/}
                        {/*    <div class="col-md-4">*/}
                        {/*         */}
                        {/*    </div>*/}
                        {/*    <div class="col-md-4">*/}
                        {/*        */}
                        {/*    </div>*/}
                        {/*    <div class="col-md-4">*/}
                        {/*         */}
                        {/*    </div>*/}
                        {/*</div>*/}
                      </div>
                      <div className="form-group">
                        <label>Mobile Number <span className="reguired" >*</span></label>
                        <input type="text" className="form-control validate[required] phone_number" autoComplete="off" id="phone_number" name="data[Register][phone_number]" style={{ "margin-bottom": "13px", border: "1px solid #000000 !important" }} />
                        {/*<small>OTP will be send to this mobile number</small>*/}
                        {/*<small style="float:right"><input type="button" id="resend_otp" value="Resend OTP ?"></small>*/}
                      </div>
                      {/*<div class="form-group otp">*/}
                      {/*    <label>OTP</label>*/}
                      {/*    <input type="text" id="otp" class="form-control" name="data[Register][otp]"/>*/}
                      {/*</div>*/}
                      <input type="submit" className="btn send-otp" defaultValue="SUBMIT" />
                    </form>
                    <div className="advanced-searc-lnk">
                      <a href="/register">New? Register here!</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="container">
          <div className="">
            <ul style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="ullist">
              {/* Logo - Left side */}
              <li style={{ marginRight: 'auto' }} className="matrimonylogo">
                <Link className="" to="/">
                  <img
                    className="matrimonylogo"
                    src={require('../../assests/images/kalyana-saptha-pathi-logo.png')}
                    alt="Matrimony Logo"
                    loading="lazy"
                  />
                </Link>
              </li>


              {/* Right side items container */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                {(localStorage.user_token) ? (
                  <>
                    <li style={{ listStyle: 'none' }} className="liullist">
                      <a href='/myprofile' style={{ textTransform: 'none', cursor: "pointer" }} className="mtop">
                        <button type="button" className={`btn btn-outline-light login-btn ${!headerVisible ? 'no-hover' : ''}`}
                          style={!headerVisible ? headerStyle : {}}>My Profile</button>
                      </a>
                    </li>
                    <li style={{ listStyle: 'none' }} className="liullist">
                      <a onClick={onlogout} style={{ textTransform: 'none', cursor: "pointer" }} className="mtop">
                        <button type="button" className={`btn btn-outline-light login-btn ${!headerVisible ? 'no-hover' : ''}`}
                          style={!headerVisible ? headerStyle : {}}>Logout</button>
                      </a>
                    </li>
                  </>
                ) : (
                  <>
                    <li style={{ listStyle: 'none' }} className="liullist">
                      <a href='/registration' style={{ textTransform: 'none', cursor: "pointer", color: "", fontSize: "22px", fontWeight: "700" }} className="mtop">
                        <span className="already-registered-text" style={!headerVisible ? headerStyle : {}}>
                          Register
                        </span>
                      </a>
                    </li>
                    <li style={{ listStyle: 'none' }} className="liullist">
                      <a onClick={handleOpen} style={{ textTransform: 'none', cursor: "pointer" }} className="mtop">
                        <button type="button" className={`btn btn-outline-light login-btn ${!headerVisible ? 'no-hover' : ''}`}
                          style={!headerVisible ? headerStyle : {}}>Login</button>
                      </a>
                    </li>
                  </>
                )}


                <li style={{ listStyle: 'none' }} className="liullist">
                  <a href="tel:+919652966888" style={{ textTransform: 'none', cursor: "pointer", textDecoration: 'none' }}>
                    <button type="button" className="btn btn-outline-light call-button" style={!headerVisible ? { ...headerStyle, border: "1px solid black", color: "#FCD300", background: "#B21919" } : {}}>Call : +91-9652966888</button>
                  </a>
                </li>


                <li style={{ listStyle: 'none' }} className="liullist">
                  <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '0px' }}>
                    {/* Hamburger Icon */}
                    <div
                      className="hamburger-icon"
                      onClick={() => setSidebarOpen(true)}
                      style={!headerVisible ? headerStyle : {}}
                    >
                      ☰
                    </div>
                    
                    {/* Add Backdrop Overlay */}
                    {isSidebarOpen && (
                      <div
                        style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          zIndex: 1040,
                        }}
                        onClick={() => setSidebarOpen(false)}
                      />
                    )}
                    {/* Sidebar */}
                    <div
                      style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: '280px',
                        height: '100vh',
                        backgroundColor: '#EDE8D0',
                        borderLeft: '1px solid #e0e0e0',
                        paddingLeft: '0px',
                        zIndex: 1050,
                        transform: isSidebarOpen ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                        overflowY: 'auto'
                      }}
                    >
                      {/* Close Button */}
                      <div
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          top: '16px',
                          right: '16px',
                          fontSize: '22px',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          zIndex: 2000,
                        }}
                        onClick={() => setSidebarOpen(false)}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        ×
                      </div>


                      {/* Sidebar Content */}
                      <div style={{ marginTop: '40px' }}>
                        <Navbar inSidebar={true} closeSidebar={() => setSidebarOpen(false)} />
                      </div>
                    </div>

                  </div>
                </li>
              </div>
            </ul>
          </div>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Button className='timee'
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  width: "35px",
                  height: "35px",
                  minWidth: "35px",
                  color: "#BA3E3E",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 10,
                }} onClick={handleClose} variant="primary">
                <CancelIcon className='rasathi' />
              </Button>
              <Tabp />
            </Box>
          </Modal>

          <style jsx>
            {`
            .ullist {
              list-style-type: none;
              margin: 0;
              padding: 0;
              overflow: hidden;
              background-color: transparent;
              display: flex !important;
              justify-content: space-between !important;
              align-items: center !important;
            }

            .ullist .liullist {
              float: none;
            }

            .ullist .liullist a {
              display: block;
              text-align: center;
              padding: 0px;
              text-decoration: none;
            }

            .matrimonylogo {
              max-width: 260px; 
              height: auto;     
              object-fit: contain;  
              display: block; 
              border-bottom-left-radius: 15px;
              border-bottom-right-radius: 15px;
              margin-left: 10px;
              padding-top:0px !important;
            }

            .already-registered-text {
              color: white;
              font-size: 24px;
              font-weight: bold;
              white-space: nowrap;
            }

            .btn.login-btn {
              background-color: transparent ;
              border: 2px solid white ;
              color: white ;
              padding: 8px 20px ;
              font-size: 22px ;
              font-weight: 400 ;
              border-radius: 8px ;
              transition: all 0.3s ease ;
            }

            .btn.login-btn:hover {
              background-color: white ;
              color: #000000 ;
            }

            .btn.call-button {
              background-color: transparent ;
              border: 2px solid white ;
              color: white ;
              padding: 8px 20px ;
              font-size: 24px ;
              font-weight: 400 ;
              border-radius: 8px ;
              transition: all 0.3s ease ;
              white-space: nowrap;
            }

            .btn.call-button:hover {
              background-color: white ;
              color: #333 ;
            }

            .hamburger-icon {
              cursor: pointer;
              font-size: 40px;
              padding: 5px 12px;
              color: white;
              transition: all 0.2s;
              border-radius: 4px;
            }

            .hamburger-icon:hover {
              background-color: rgba(255,255,255,0.1);
            }

            @media (max-width: 576px) {
              .ullist {
                flex-direction: column !important;
                align-items: center !important;
                padding: 0;
              }
              .matrimonylogo {
                max-width: 250px !important; /* Match image logo size */
                margin: 0 auto 5px auto; /* Centered with bottom margin */
                border-radius: 0; /* Match flat design */
              }
              .ullist > div {
                width: 85%;
                display: flex !important;
                justify-content: space-between !important; /* Left, center, right alignment */
                gap: 0 !important; /* No gap for exact positioning */
                flex-wrap: nowrap; /* Prevent wrapping */
              }
              .already-registered-text {
                font-size: 18px !important; /* Match image text size */
                white-space: nowrap;
                margin: 0;
                align-self: flex-start; /* Align to left */
              }
              .btn.login-btn {
                padding: 8px 20px !important; /* Match image button size */
                font-size: 18px !important;
                margin: -14px 0px -26px;
                background-color: #fff !important; /* White background */
                color: #000 !important; /* Black text */
                border: none !important; /* No border */
                align-self: center; /* Center the Login button */
              }
              .hamburger-icon {
                font-size: 30px; /* Match image icon size */
                padding: 5px 10px;
                margin: 0;
                align-self: flex-end; /* Align to right */
              }
              .btn.call-button {
                display: none;
              }
                .mtop{
                margin-right: 70px;
                }
            }
            
            @media (max-width: 768px) {
              .btn.login-btn,
              .btn.call-button {
                padding: 6px 12px !important;
                font-size: 14px !important;
              }
              
              .already-registered-text {
                font-size: 14px !important;
              }

              .hamburger-icon {
                font-size: 24px;
              }
            }

            @media (max-width: 992px) {
              .btn.call-button {
                display: none;
              }
            }
          `}
          </style>
        </div>
      </div >
    </header>
  )
}
export default Header;